import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { IPayment } from "../model/payment.model";
import { stripeAccount } from "../model/stripe-account.model";

@Injectable()
export class BillingService{
    Courses$!:Observable<IPayment[]>;
    private http = inject(HttpClient);
    authService = inject(AuthenticationService);
    
    getPayments(): Observable<IPayment[]> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        return this.http.get<IPayment[]>( environment.API_URL + `/api/finance/myRevenue`, options);
    }  
   
    createStripeAccount(selectedCountry: string): Observable<string> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        let param = {
            refreshUrl: window.location.href,
            returnUrl: window.location.href,    
            country: selectedCountry
        };

        return this.http.post<string>( environment.API_URL + `/api/finance/CreateStripeAccount`, param, options);
    }  
       
    updateStripeAccount(code: string): Observable<string> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        let param = {
            code: code
        };

        return this.http.post<string>( environment.API_URL + `/api/finance/UpdateStripeAccount`, param, options);
    }  

    getStripeAccount(): Observable<stripeAccount> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        return this.http.get<stripeAccount>( environment.API_URL + `/api/finance/GetStripeAccount`, options);
    }    
          
    getStripeAccountLink(): Observable<string> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        let param = {
            refreshUrl: window.location.href,
            returnUrl: window.location.href
        };

        return this.http.post<string>( environment.API_URL + `/api/finance/GetStripeAccountLink`, param, options);
    }
}